import React from 'react';

import {
  PaymentMethodWidgetDocument,
  SavePaymentMethodMappingInput,
  usePaymentMethodWidgetQuery,
  useSavePaymentMethodMappingsMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  subsidiaryId: string;
  unmappedStrings: string[];
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = usePaymentMethodWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const paymentMethods = tuple.data?.store?.paymentMethodMappings.map((node): types.IRow => ({
        id: node.id,
        isTaxable: node.isTaxable,
        paymentMethodText: node.paymentMethodText,
        netSuitePaymentMethod: node.paymentMethod ? {
          id: node.paymentMethod.id,
          name: `${node.paymentMethod.name} (${node.paymentMethod.internalId})`
        } : null
      })) ?? [];

      const data: IData = {
        subsidiaryId: tuple.data?.store?.subsidiary?.id ?? '',
        unmappedStrings: tuple.data?.allRawPaymentMethods.filter(rawValue => !paymentMethods.some(pm => pm.paymentMethodText === rawValue)) ?? [],
        formState: {
          paymentMethods
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSavePaymentMethods(storeId: string) {
  const [fnMutate, tuple] = useSavePaymentMethodMappingsMutation({
    refetchQueries: [
      {
        query: PaymentMethodWidgetDocument,
        variables: { storeId }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          input: {
            storeId,
            paymentMethods: formState.paymentMethods.map((paymentMethod): SavePaymentMethodMappingInput => ({
              id: paymentMethod.id || undefined,
              paymentMethodText: paymentMethod.paymentMethodText,
              paymentMethodId: paymentMethod.netSuitePaymentMethod?.id,
              isTaxable: paymentMethod.isTaxable
            }))
          }
        }
      });
    },
    [fnMutate, storeId]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
